import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import { ChevronLeft, Delete } from '@mui/icons-material'
import theme from '../theme'

interface Props {
  campaignId: number
  onEdit: () => void
  openDeleteModal: (id: number) => void
  hasStarted: boolean
}

const CampaignToolbar = ({
  campaignId,
  onEdit,
  openDeleteModal,
  hasStarted
}: Props) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: theme.space['8'],
        justifyContent: 'space-between'
      }}
    >
      <Button
        variant="contained"
        size="small"
        color="secondary"
        title="Back"
        onClick={() => navigate('/')}
      >
        <ChevronLeft sx={{ color: theme.palette.text.primary }} />
      </Button>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: theme.space['8'],
        }}
      >
        <Button
          color="secondary"
          variant="contained"
          onClick={onEdit}
          title="Edit"
        >
          <Typography variant="ui-1" color={theme.palette['sage-900']}>
            Edit
          </Typography>
        </Button>
        <Button
          variant="contained"
          size="small"
          color="secondary"
          title="Delete"
          onClick={() => openDeleteModal(campaignId)}
          disabled={hasStarted}
        >
          <Delete
            fontSize="small"
            sx={{
              color: hasStarted
                ? theme.palette['sage-300']
                : theme.palette.text.primary
            }}
          />
        </Button>
      </Box>
    </Box>
  )
}

export default CampaignToolbar
